import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import WelcomeExcellence from "./sections/WelcomeExcellence";
import TheStrategicAdvantage from "./sections/TheStrategicAdvantage";
import PremiumAssetsPreview from "./sections/PremiumAssetsPreview";
import OurCoreExpertise from "./sections/OurCoreExpertise";
import IntermediaryExcellence from "./sections/IntermediaryExcellence";
import LegalInsights from "./sections/LegalInsights";
import BeginYourAcquisition from "./sections/BeginYourAcquisition";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <WelcomeExcellence />
      <TheStrategicAdvantage />
      <PremiumAssetsPreview />
      <OurCoreExpertise />
      <IntermediaryExcellence />
      <LegalInsights />
      <BeginYourAcquisition />
      <Footer />
    </div>;
}